import { render } from "./JsonTreeView.vue?vue&type=template&id=2db80316&scoped=true&ts=true"
import script from "./JsonTreeView.vue?vue&type=script&lang=ts"
export * from "./JsonTreeView.vue?vue&type=script&lang=ts"

import "./JsonTreeView.vue?vue&type=style&index=0&id=2db80316&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db80316"]])

export default __exports__